// extracted by mini-css-extract-plugin
module.exports = {"link-container":"_89b4965636--link-container--b6BMy","link":"_89b4965636--link--k9NUU"};